import { useMutation, useQueryClient } from 'react-query';
import request from '../../../../../helpers/request';
import { queryKeysShutdowns } from '../../constants/queryKeys';

export const resetDefaultFilter = async (id) => {
  const data = { id, value: false };

  return await request.put(
    '/Filter/default',
    data,
    'Произошла ошибка при сбросе фильтра',
    'Error',
    null,
    { type: 'ALERT' }
  );
};

const useResetDefaultFilter = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(resetDefaultFilter, {
    onSuccess: (data) => {
      if (data === 'Error') return;

      queryClient.invalidateQueries(queryKeysShutdowns.savedFilters());
    },
  });

  return {
    isResetFilterLoading: mutation.isLoading,
    resetFilter: mutation.mutateAsync,
  };
};

export default useResetDefaultFilter;
